"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _trackingLink = _interopRequireDefault(require("@insided/deprecated-preact-components/link/tracking-link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ContentCategory = _interopRequireDefault(require("./ContentCategory"));

var _ChevronIcon = _interopRequireDefault(require("./ChevronIcon"));

var CategorySection = function CategorySection(props) {
  var _parentCategory$child;

  var parentCategory = props.parentCategory,
      setCategories = props.setCategories,
      resetCategories = props.resetCategories,
      collapsed = props.collapsed,
      customCollapsedCategories = props.customCollapsedCategories,
      isDefaultCollapsed = props.isDefaultCollapsed,
      handleCollapse = props.handleCollapse,
      unreadTopicsAndRepliesCount = props.unreadTopicsAndRepliesCount,
      displayUnreadPostCount = props.displayUnreadPostCount,
      attachmentCdn = props.attachmentCdn;
  var isCollapsed = customCollapsedCategories.includes(parentCategory.id) ? collapsed[parentCategory.id] : isDefaultCollapsed;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('category-section', 'table', "qa-category".concat(isCollapsed ? ' is-collapsed' : '')),
    id: "category-".concat(parentCategory.id)
  }, (0, _preact.h)("div", {
    className: "category-title"
  }, parentCategory.parentId && (0, _preact.h)(_ChevronIcon.default, {
    icon: "chevronLeft",
    title: "category reset",
    className: "category-step-backward",
    onClick: function onClick() {
      return resetCategories();
    }
  }), (0, _preact.h)("h2", null, (0, _preact.h)(_trackingLink.default, {
    tag: "a",
    href: (0, _absoluteUrlRuntime.resolveUrl)(parentCategory.url),
    className: "link--subforum qa-category-link",
    track: {
      type: 'Category Clicked',
      category_title: parentCategory.title,
      category_url: parentCategory.url,
      click_source: 'Homepage',
      category_type: 'parent category'
    },
    gaEvents: {
      eventCategory: 'Homepage',
      eventAction: 'Category clicked',
      eventLabel: {
        Title: parentCategory.title,
        Link: parentCategory.url,
        Type: 'parent category'
      }
    }
  }, parentCategory.title)), !parentCategory.parentId && (0, _preact.h)(_ChevronIcon.default, {
    icon: "chevronUp",
    title: "forum expand",
    className: "table__collapse",
    onClick: function onClick(e) {
      return handleCollapse(e, parentCategory.id);
    }
  })), parentCategory.description && (0, _preact.h)("div", {
    className: (0, _classnames.default)('category-description', 'text--meta', {
      'subcategory-description': parentCategory.parentId
    })
  }, parentCategory.description), (0, _preact.h)("div", {
    className: "table forum-table js-collapse-content js-unread-overview".concat(isCollapsed ? ' is-hidden' : '')
  }, parentCategory === null || parentCategory === void 0 ? void 0 : (_parentCategory$child = parentCategory.children) === null || _parentCategory$child === void 0 ? void 0 : _parentCategory$child.map(function (category) {
    return (0, _preact.h)(_ContentCategory.default, {
      key: "category-".concat(category.id),
      setCategories: setCategories,
      category: category,
      displayUnreadPostCount: displayUnreadPostCount,
      attachmentCdn: attachmentCdn,
      unreadTopicsAndRepliesCount: unreadTopicsAndRepliesCount
    });
  })));
};

var _default = CategorySection;
exports.default = _default;